export const Languages = Object.freeze({
  ENGLISH: { key: 'en', value: 'English' },
  HINDI: { key: 'hi', value: 'Hindi' },
});

export const getLanguages = () => Object.values(Languages).map((language) => ({
  id: language.key,
  text: language.value,
  obj: language,
}));
